import React from 'react'
import _ from 'lodash';
var tu = require('tracking-url');

class Fulfillment extends React.Component {
  constructor(props) {
    super(props)
    this.renderFulfillment = this.renderFulfillment.bind(this)
  }
  renderFulfillment() {
    if (this.props.order && this.props.order.fulfillment) {
      const { fulfillment } = this.props.order;
      const track = tu(fulfillment.tracking_number)
      if (fulfillment.hasOwnProperty('sage_order_id')) {
        return (
          <div key={fulfillment.tracking_number}>
            <p key="UPS">Carrier: <strong>UPS</strong></p><br />
            <p key={fulfillment.sage_order_id}>SAGE ORDER ID: <strong>{fulfillment.sage_order_id}</strong></p><br />
            <p key={fulfillment.ship_service}>SHIPPING SERVICE: <strong>{fulfillment.ship_service}</strong></p><br />
            <p key={fulfillment.xcarrier_delivery_id}>CARRIER DELIVER ID: <strong>{fulfillment.xcarrier_delivery_id}</strong></p><br />
            <h3 key={`${fulfillment.tracking_number}h3`}>
              Tracking Number: 
              {(track && track.url) 
              ? <a href={track.url} target="_blank" rel="noopener noreferrer">{fulfillment.tracking_number}</a>
              : <span>{fulfillment.tracking_number}</span>}
            </h3>
          </div>
        )
      } else {
        const boxes = _.map(fulfillment.boxes, box => {
          const boxItems = _.map(box.items, i => (
            <div key={i.order_item_id + 7000}>
              <p key={i.order_item_id}>Line Item Id: <strong>{i.order_item_id}</strong> </p>
              <p key={i.order_item_id + 9000}>SKU: <strong>{i.sku}</strong> </p>
              <p>&nbsp;</p>
            </div>
          ));
          if (box.tracking_number) {
            const track = tu(box.tracking_number)
            return (
              <div key={box.tracking_number}>
                <p key={box.carrier}>Carrier: <strong>{box.carrier}</strong></p>
                <p key={box.method}>Method: <strong>{box.method}</strong></p>
                <h3 key={`${box.tracking_number}h3`}>
                  Tracking Number:
                  {(track && track.url)
                    ? <a target="_blank" href={tu(box.tracking_number).url}>{box.tracking_number}</a>
                    : box.tracking_number
                  }
                </h3>
                {boxItems}
              </div>
            );
          } else {
            return "";
          }
        });
        return boxes;
      }
    }
  }
  render() {
    return (
      <div>
        <h2>Fulfillment</h2>
        <div style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
          {this.renderFulfillment()}
        </div>
      </div>
    )
  }

}
export default Fulfillment


// WEBPACK FOOTER //
// ./src/components/orders/Common/Fulfillment.js